/// <amd-module name="Wit/UI/Common/ColorUtilities" />

export const COLOR_TRANSPARENT = "transparent";

export const COLOR_WHITE = "ffffff";

const hexColorMatcher = /^[0-9a-fA-F]+$/;

/**
 * Parse color to format #aabbcc
 * @param rawColor Raw string for color
 * @param defaultColor will be changed to default one if rawColor is not fulfilled
 * @param alphaRequired Color has alpha and don't need to remove it in result 
 */
export function parseColor(rawColor: string, alphaRequired: boolean = false, defaultColor: string = COLOR_WHITE): string {
    if (!rawColor) {
        rawColor = defaultColor;
    }

    if(rawColor[0] === '#'){
        rawColor = rawColor.substring(1);
    }

    if (rawColor === 'undefined') {
        rawColor = defaultColor;
    }
    // CSS allows colors to look like #rgb, #rgba, #rrggbb
    if ((rawColor.length === 3 || rawColor.length === 4 || rawColor.length === 6) && hexColorMatcher.test(rawColor)) {
        rawColor = "#" + rawColor;
    }
    // looking for #argb color 
    if(rawColor.length === 8 && hexColorMatcher.test(rawColor)){
        if(alphaRequired){
            rawColor = "#" + rawColor;   
        }
        else{
            // remove transparency
            rawColor = `#${rawColor.substring(rawColor.length - 6)}`;
        }
    }

    return rawColor;
}

/**
 * Convert a hex color to numeric r g b value
 * @param color Color in format #aabbcc
 */
export function hexToRgb(color: string): [number, number, number] {
    if (color.length !== 7 || color[0] !== "#") {
        throw new Error("Expected color in format #aabbcc");
    }

    return [parseInt(color.substr(1, 2), 16), parseInt(color.substr(3, 2), 16), parseInt(color.substr(5, 2), 16)];
}
